import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpRequest,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { inject } from '@angular/core';

import { ToastService } from '../services/app';

export function errorInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const toastService = inject(ToastService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // 🛑 Log error to the console (optional)
      console.error('Error occurred:', error);

      let errorMessage = '';
      if (error.status === 0) {
        // Network error
        errorMessage = 'Kết nối mạng không ổn định. Vui lòng thử lại sau!';
      } else {
        // API error
        errorMessage = `Lỗi (${error.status}): ${error.error?.message || 'Lỗi không xác định!'}`;
      }
      toastService.showDanger(errorMessage, 'Lỗi');

      return throwError(() => error);
    }),
  );
}
